import Link from "next/link";

import MainButton from "~/components/common/mainButton";
import { useLanguage } from "~/contexts/providers/language";
import englishTranslations from "~/localization/en";
import frenchTranslations from "~/localization/fr";

import styles from "./buttons.module.scss";

const PrivateEventsButtons = () => {
  const { language } = useLanguage();
  const privateEventsTexts =
    language === "En"
      ? englishTranslations.privateEventsPage
      : frenchTranslations.privateEventsPage;
  const email = "events@lesilencio.com";
  return (
    <div className={styles.child}>
      <Link href={"/private-events/form"}>
        <MainButton theme="white">
          {privateEventsTexts.fillOurContactForm.buttonText} →
        </MainButton>
      </Link>
      <a href={`mailto:${email}`}>{privateEventsTexts.form.emailUsButton} @</a>
    </div>
  );
};

export default PrivateEventsButtons;
